import { Icon } from "../icons";

const SAMPLES = [
  {
    href: "/samples/pgr-robo-cctv.txt",
    title: "Robo y CCTV fuera de línea",
    description: "Urgencia, visita técnica, responsable, plazo e informe posterior.",
  },
  {
    href: "/samples/pgr-cotizacion-nocturna.txt",
    title: "Cotización de vigilancia nocturna",
    description: "Caso comercial con dotación, tecnología, plazo y reunión de seguimiento.",
  },
  {
    href: "/samples/pgr-visita-tecnica.txt",
    title: "Visita técnica de control de acceso",
    description: "Coordinación en terreno, diagnóstico, repuestos y evidencia técnica.",
  },
] as const;

export function PilotSampleChats() {
  return (
    <section className="pilot-section">
      <div className="pilot-section-heading">
        <div>
          <p className="section-kicker">IMPORTACIÓN CONTROLADA</p>
          <h2>Prueba el importador con chats ficticios</h2>
          <p>Los archivos usan el formato de exportación de WhatsApp y no contienen datos de clientes reales.</p>
        </div>
      </div>
      <div className="pilot-report-grid">
        {SAMPLES.map((sample) => (
          <article key={sample.href}>
            <span><Icon name="download" size={19} /></span>
            <div>
              <strong>{sample.title}</strong>
              <p>{sample.description}</p>
              <a className="text-link-button" download href={sample.href}>Descargar .txt</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
